import Vue from 'vue'
import store from '@/store'
import { isEmptyArray } from './stringUtil.js'
// 权限指令
const has = Vue.directive('has', {
  inserted: function (el, binding) {
    // 获取按钮权限
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})
const star = Vue.directive('star', {
  inserted: function (el, binding) {
    // 获取按钮权限
    if (!Vue.prototype.$_has(binding.value)) {
      el.innerHTML = '*****'
    }
  }
})
// 权限检查方法
Vue.prototype.$_has = function (value) {
  const btnPermissionsArr = store.getters.buttonList
  if (isEmptyArray(btnPermissionsArr)) {
    return false
  }
  for (let i = 0; i < btnPermissionsArr.length; i++) {
    if (btnPermissionsArr[i].value === value) {
      return true
    }
  }
  return false
}
export default { has, star }
